import React from "react";
import BasicAddressData from "../BasicAddressData/BasicAddressData";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import ColDynamic from "../WrapperComponents/ColDynamic";
import InputComponent from "../../UI/InputComponent/InputComponent";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";
import DatePicker from "../../UI/DatePicker/DatePicker";
import DatepickerComponent from "../../UI/DatePicker/DatepickerComponent";
import "./MappedRegistrationComponent.css";
import { Divider } from "antd";

const MappedRegistrationComponent = (props) => {
  const reviserRegistrationData = props.parentState.newFormData[
    props.group
  ].find((element) => element.id === props.id);

  const reviserArrayLength =
    props.parentState.newFormData[props.group].length > 1;

  return (
    <div className="form-group ">
      <Row>
        <Col>
          <InputComponent
            value={reviserRegistrationData.brReg}
            id={`reviser-registration-id${props.id}${props.regId}`}
            name="brReg"
            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: props.group }}
            controlLabel={props.regLabel || "Broj registracije"}
          />
        </Col>

        <Col>
          <DatepickerComponent
            required={props.required}
            errorBorderColor={
              props.required &&
              props.parentState.error &&
              reviserRegistrationData.datReg < 1 &&
              "red"
            }
            id={`dat-reg-reviser-registration${props.id}${props.regId}`}
            width={"100%"}
            value={reviserRegistrationData.datReg}
            handleDayClick={props.handleDayClick}
            controlLabel={props.datLabel || "Datum registracije"}
            index={{ id: props.id, group: props.group, prop: "datReg" }}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputComponent
            value={reviserRegistrationData.nazTijela}
            id={`naziv-tijela-reviser-registration${props.id}${props.regId}`}
            name="nazTijela"
            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: props.group }}
            controlLabel={"Naziv nadležnog tijela"}
          />
        </Col>
        <Col>
          {props.brRegOrig && (
            <InputComponent
              value={reviserRegistrationData.brRegOrig}
              id={`registarski-broj-nadleznog-tijela${props.id}${props.regId}`}
              name="brRegOrig"
              onChange={props.mappedUserInputHandler}
              objData={{ id: props.id, group: props.group }}
              controlLabel={"Registarski broj nadležnog tijela"}
            />
          )}
        </Col>
      </Row>

      <BasicAddressData
        required={props.requiredAddress}
        requiredKbr={props.requiredKbr}
        onChange={props.mappedUserInputHandler}
        hackId={`rev-reg-data${props.regId}`}
        objData={{ group: props.group, id: props.id }}
        address={reviserRegistrationData}
        {...props}
      />
      <Row>
        <ColDynamic className="col-lg-4">

          {props.parentState.newFormData[props.group].length - 1 === props.idZaBtn ?
            <ButtonComponent
              id={`registration-multiply${props.id}${props.regId}`}
              onClick={(e) =>
                props.multiplyComponent(e, { formGroup: props.group })
              }
            >
              Dodaj novi
            </ButtonComponent>
            :null
          }

        </ColDynamic>
        <ColDynamic className="col-lg-4">
          {reviserArrayLength && (
            <ButtonComponent
              variant="danger"
              id={`registration-remove${props.id}${props.regId}`}
              onClick={(e) =>
                props.removeComponentHandler(e, {
                  formGroup: props.group,
                })
              }
            >
              Ukloni
            </ButtonComponent>
          )}
        </ColDynamic>
      </Row>
    </div>
  );
};

export default MappedRegistrationComponent;
